import { useSyncExternalStore } from 'react';
import { getHRState, subscribeHR } from '../utils/hrStore';
import type { HRState } from '../utils/hrStore';

export function useHRStore(): HRState {
  return useSyncExternalStore(subscribeHR, getHRState, getHRState);
}
